(function () {
  'use strict';

  function initMap(root) {
    root.querySelectorAll('[data-mno-map]').forEach((map) => {
      if (map.dataset.mnoReady === 'true') return;
      map.dataset.mnoReady = 'true';
      const stages = Array.from(map.querySelectorAll('[data-mno-stage]'));
      stages.forEach((stage) => {
        const button = stage.querySelector('[data-mno-stage-button]');
        if (!button) return;
        button.addEventListener('click', () => {
          stages.forEach((item) => item.removeAttribute('data-current'));
          stage.setAttribute('data-current', 'true');
          stages.forEach((item) => {
            const itemButton = item.querySelector('[data-mno-stage-button]');
            if (itemButton) itemButton.setAttribute('aria-pressed', String(item === stage));
          });
        });
      });
    });
  }

  function numberValue(input) {
    const normalized = String(input.value || '').replace(',', '.').replace(/[^0-9.]/g, '');
    const value = Number(normalized);
    return Number.isFinite(value) && value > 0 ? value : null;
  }

  function initFit(root) {
    root.querySelectorAll('[data-mno-fit]').forEach((panel) => {
      if (panel.dataset.mnoReady === 'true') return;
      panel.dataset.mnoReady = 'true';
      const form = panel.querySelector('[data-mno-fit-form]');
      const result = panel.querySelector('[data-mno-fit-result]');
      if (!form || !result) return;
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const width = numberValue(form.elements.width);
        const depth = numberValue(form.elements.depth);
        const height = numberValue(form.elements.height);
        const neededWidth = Number(panel.dataset.width) || null;
        const neededDepth = Number(panel.dataset.depth) || null;
        const neededHeight = Number(panel.dataset.height) || null;
        if (!width || !depth || !height) {
          result.textContent = 'Informe as três medidas disponíveis para verificar o espaço.';
          result.dataset.state = 'attention';
          return;
        }
        if (!neededWidth || !neededDepth || !neededHeight || panel.dataset.confirmed !== 'true') {
          result.textContent = 'As medidas do produto precisam de confirmação. Envie seu espaço ao especialista antes da instalação.';
          result.dataset.state = 'attention';
          return;
        }
        const fits = width >= neededWidth && depth >= neededDepth && height >= neededHeight;
        result.textContent = fits
          ? 'O equipamento cabe nas medidas informadas. Confirme abertura, ventilação, passagem e instalação.'
          : 'O espaço informado é menor que uma das dimensões do equipamento. Revise as medidas com um especialista.';
        result.dataset.state = fits ? 'success' : 'attention';
      });
    });
  }

  function init(root) {
    initMap(root || document);
    initFit(root || document);
  }

  window.MakNorteOperation = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
